module.exports = __webpack_public_path__ + "media/images/faqs/bg-1152-01fa587780fc475c9efef1d2b7ce09e1.png";